
// import React from 'react';
// import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
// import Login from './ui/Login';
// import Signup from './ui/Signup';

// // Placeholder for authentication status
// const isAuthenticated = false; // Replace with actual authentication logic

// const App: React.FC = () => {
//     return (
//         <Router>
//             <Routes>
//                 <Route path="/" element={<Login />} />
//                 <Route path="/signup" element={<Signup />} />
//                 {/* <Route path="/dashboard" element={<Dashboard />} /> */}
//             </Routes>
//         </Router>
//     );
// };


// export default App;






// import React from "react";
// import { Routes, Route, Navigate } from "react-router-dom";
// import { Toaster } from "react-hot-toast";
// import { useGlobalContext } from "./context/globalContext";

// // Header Components
// import HeaderTop from "./components/HeaderTopContainer";
// import HeaderMain from "./components/HeaderMain";
// import CategoryItemHeader from "./components/CategoryItemHeader";

// // Page Components
// import LandingPage from "./pages/LandingPage";
// //import CategoryItem from "./pages/CategoryItem";
// //import AllProduct from "./pages/AllProduct";
// import AdminDashboard from "./pages/AdminPage";
// import Login from "./pages/LoginPage";

// import { createBrowserRouter, RouterProvider } from 'react-router-dom';
// import CartPage from "./pages/CartPage";



// // Background Effect Component
// const BackgroundEffect: React.FC = () => (
//   <div className="absolute inset-0 overflow-hidden">
//     <div className="absolute inset-0">
//       <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(ellipse_at_top,rgba(16,185,129,0.3)_0%,rgba(10,80,60,0.2)_45%,rgba(0,0,0,0.1)_100%)]" />
//     </div>
//   </div>
// );

// const App: React.FC = () => {
//   const { user } = useGlobalContext();

//   return (
//     <div className="min-h-screen bg-gray-900 text-white relative overflow-hidden">
//       {/* Header Components */}
//       {/* <HeaderTop />
//       <HeaderMain />
//       <CategoryItemHeader /> */}

//       {/* Background Effect */}
//       <BackgroundEffect />

//       {/* Page Routes */}
//       <main className="relative z-50 pt-20">
//         <Routes>
//           <Route path="/" element={<LandingPage />} />
//           {/* <Route path="/category/:category" element={<CategoryItem />} /> */}
//           {/* <Route path="/products" element={<AllProduct />} /> */}
//           <Route path="/cart" element={<CartPage />} />
//           <Route path="/admin" element={user?.role === "admin" ? <AdminDashboard /> : <Navigate to="/login" />} />
//           <Route path="/login" element={<Login />} />
//         </Routes>
//       </main>

//       <Toaster />
//     </div>
//   );
// };

// export default App;





// import React from "react";
// import Sidebar from "./components/Sidebar";
// import Header from "./components/Header";
// import Dashboard from "./pages/Dashboard";
// import { ThemeProvider } from "./context/ThemeContext";

// const App: React.FC = () => {
//   return (
//     <ThemeProvider>
//       <div className="d-flex">
//         <Sidebar />
//         <div className="flex-grow-1">
//           <Header />
//           <Dashboard />
//         </div>
//       </div>
//     </ThemeProvider>
//   );
// };

// export default App;


// import React from "react";
// import { ThemeProvider } from "./context/ThemeContext";
// import Layout from "./components/Layout";

// const App: React.FC = () => {
//   return (
//     <ThemeProvider>
//       <Layout />
//     </ThemeProvider>
//   );
// };

// export default App;

import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import Layout from "./components/Layout";
import Login from "./pages/LoginPage";

const App: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("token")
  );

  // 🔁 Listen for auth changes from login/logout pages
  useEffect(() => {
    const handleAuthChange = () => {
      setIsAuthenticated(!!localStorage.getItem("token"));
    };

    window.addEventListener("authChange", handleAuthChange);

    return () => {
      window.removeEventListener("authChange", handleAuthChange);
    };
  }, []);

  return (
    <ThemeProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            isAuthenticated ? <Layout /> : <Navigate to="/login" replace />
          }
        />
      </Routes>
    </ThemeProvider>
  );
};

export default App;
